import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.png";
import covid from "../assets/img/covid.png";
import book from "../assets/img/book.gif";
import code from "../assets/img/code.png";
import tuiter from "../assets/img/tuiter.png";
import teacher from "../assets/img/teacher.jpeg";
import ratein from "../assets/img/ratein.jpeg";
import emochat from "../assets/img/emochat.jpeg";
import dungeon from "../assets/img/dungeon.png";
import bird from "../assets/img/bird.png";
import chatApp from "../assets/img/chatApp.png";
import collabPaint from "../assets/img/collabPaint.png";
import heart from "../assets/img/heart.jpeg";

import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projectsFirst = [
    {
      title: "Tuiter App",
      description: "A twitter clone app built using React, Node, Express and MongoDB.",
      img: tuiter,
      prjUrl: 'https://github.com/kartikeydwi1997/tuiter-react-web-app/tree/A9',
      url: 'https://a9--benevolent-cheesecake-ad7ee4.netlify.app/tuiter/home',
      tech: "NodeJS, React, Redux, MongoDB, Mongoose"
    },
    {
      title: "Code Connect",
      description: "A collaborative code editor to allow you to code together over the internet",
      img: code,
      prjUrl: 'https://github.com/frankhart2018/cs-5610-404-not-found',
      url: 'https://master--effulgent-pothos-411248.netlify.app/login',
      tech: "NodeJS, React, Redux, MongoDB, Mongoose, AWS, Fast API, Material UI"
    },
    {
      title:"Distributed Chat Application",
      description: "A distributed chat application using Java RMI and Java Sockets",
      img: chatApp,
      prjUrl: 'https://github.com/kartikeydwi1997/CS6650_final_project',
      url: 'https://youtu.be/pZSko_IVI7s',
      tech: "Java, Java RMI, Java Sockets, Java Swing"
    },
    {
      title:"CollabPaint",
      description: "A high-speed collaborative painting desktop application with a good build system and additional features using DLang, SDL library, and gtkD GUI library.",
      img: collabPaint,
      prjUrl: 'https://github.com/kartikeydwi1997/CollabPaint/tree/main',
      url: 'https://www.youtube.com/watch?v=P609ZQps6CU',
      tech: "Dlang, SDL library, gtkD GUI library"
    },
    {
      title: "Covid Tracker",
      description: "React progressive web App (PWA) showing deceased, active and recovered cases of Covid virus of 196",
      img: covid,
      prjUrl: 'https://github.com/kartikeydwi1997/Covid-Tracker',
      url: 'https://kartikeydwi1997.github.io/Covid-Tracker/',
      tech: 'ReactJs, ChartJS, NodeJS, Material UI'
    },
    {
      title: "Geek Store",
      description: "Designed and developed website to allow user to purchase books using Stripe payment system and manage cart for each user.",
      img: book,
      prjUrl: 'https://github.com/kartikeydwi1997/Book-Fair/tree/master',
      url: 'https://github.com/kartikeydwi1997/Book-Fair/tree/master',
      tech: "NodeJS, MongoDB, Mongoose, EJS, Stripe"
    },
    {
      title: "Find Coach",
      description: "Website designed to allow user to find coach for different sports and manage cart for each user.",
      img: teacher,
      prjUrl: 'https://github.com/kartikeydwi1997/find-coach',
      url: 'https://github.com/kartikeydwi1997/find-coach',
      tech: "VueJS, Vuex, NodeJS"
    },
    {
      title: "Dungeon Game",
      description: "Developed a GUI application maze game in Java11 integrating design patterns like Facade, Command Design and Singleton Pattern.",
      img: dungeon,
      prjUrl: 'https://github.com/kartikeydwi1997/dungeon-game',
      url: 'https://github.com/kartikeydwi1997/dungeon-game',
      tech: "Java, Swing, Junit4"
    },
  ];

  const projectsSecond = [
    {
      title: "RateIn",
      description: "App to find the reviews of anything to make your purchase choices more curated and suitable to your needs.",
      img: ratein,
      prjUrl: 'https://github.com/kartikeydwi1997/rate-in',
      url: 'https://docs.google.com/document/d/10sP0dlaVvGujdpWH4MQWjF_71SMYvl-gYZAejW0hVpQ/edit?usp=sharing',
      tech: "Java"
    },
    {
      title: "Emochat",
      description: "App to allow user to chat with other users and share their emotions using emojis.",
      img: emochat,
      prjUrl: 'https://github.com/kartikeydwi1997/emo-chat',
      url: 'https://github.com/kartikeydwi1997/emo-chat',
      tech: "Java"
    }
  ]

  const projectsThird = [
    
    {
      title: "Analysis of BirdStrike Data",
      description: "Analysis of BirdStrike Data using SQL, R and Python",
      img: bird,
      prjUrl: 'https://github.com/frankhart2018/dbms-practicum-1',
      url: 'https://github.com/frankhart2018/dbms-practicum-1',
      tech: "SQL, Python and R"
    },
    {
      title: "Analysis of Heart Disease of a Patient using Big Data",
      description: "Analysis to identify heart disease because of several contributory risk factors such as diabetes, high blood pressure, high cholesterol, abnormal pulse rate and many other factors",
      img: heart,
      prjUrl: 'https://github.com/kartikeydwi1997/ANALYSIS-OF-HEART-DISEASE-OF-A-PATIENT-USING-BIG-DATA',
      url: 'https://github.com/kartikeydwi1997/ANALYSIS-OF-HEART-DISEASE-OF-A-PATIENT-USING-BIG-DATA',
      tech: "Hadoop, Java and Big Data"
    },
  ]
  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Projects</h2>
                  <p>I have built couple for projects related to webapps, mobile apps and few projects related to Big Data, Machine Learning and IOT.</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="first">Application/Web Apps</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Mobile Apps</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Miscellaneous</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                      <Tab.Pane eventKey="first">
                        <Row>
                          {
                            projectsFirst.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Row>
                          {
                            projectsSecond.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <Row>
                          {
                            projectsThird.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" alt="background" src={colorSharp2}></img>
    </section>
  )
}
